<template>
    <Link :href="$$route(routing)" class="btn btn--icon" :class="{'active' : activeClass}"><svg-vue :icon="icon" class="icon" /><slot></slot></Link>
</template>

<script>
import {Link} from '@inertiajs/vue3';

export default {
    name: 'SidebarNavItem',
    components: {
        Link
    },
    props: [
        'routing',
        'icon'
    ],
    computed: {
        fullRoute() {
            return this.getRoute('.' + this.routing);
        },
        activeClass() {
            return this.$route().current() === this.fullRoute ? 'active' : '';
        }
    }
};
</script>
